module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-Pathfinder-Lifestyle.4c1dade5.jpeg";